import api from './api';

export interface EasyParcelStatus {
  connected: boolean;
  enabled: boolean;
  environment?: string;
  accessTokenExpiresAt?: string;
  refreshTokenExpiresAt?: string;
  wallet?: unknown;
}

export const easyparcelService = {
  /** Admin-only: the OAuth authorize URL to redirect the browser to. */
  async getAuthorizeUrl(): Promise<{ url: string }> {
    const response = await api.get<{ url: string }>('/easyparcel/authorize-url');
    return response.data;
  },

  /** Admin-only: connection status incl. live wallet balance when connected. */
  async getStatus(): Promise<EasyParcelStatus> {
    const response = await api.get<EasyParcelStatus>('/easyparcel/status');
    return response.data;
  },
};
